

















import { Component, Mixins } from "vue-property-decorator";
import ToolItem from "basis/components/tools/ToolItem.vue";
import mixins from "@/mixins";
import { Getter } from "vuex-class";
import { showServiceDisabled } from "@/utils/helper";

@Component({
  components: {
    ToolItem
  }
})
class Tools extends Mixins(mixins.page, mixins.processOrders) {
  @Getter("auth/isLogged") isLogged;

  needAuth = false;

  typeIndex = 0;

  get bottomNav() {
    return "tools";
  }

  get title() {
    return this.$t("common.tools.title") as string;
  }

  get appbar(): any {
    return {
      back: false
    };
  }

  get tools() {
    return [
      {
        icon: require("@/assets/images/icon_instant_trade.png"),
        title: this.$t("tools.instant-trade"),
        hot: true,
        description: this.$t("tools.instant-trade.description"),
        handler: (vue: Vue) => {
          if (!this.$store.state.app.config.atm_disabled) {
            vue.$helper.toFusionPath(vue, "trade", {
              name: "instant"
            });
          } else {
            showServiceDisabled(this);
          }
        }
      },
      // {
      //   icon: require("@/assets/images/icon_4swap_mtg.png"),
      //   title: this.$t("tools.4swap"),
      //   description: this.$t("tools.4swap.description"),
      //   handler: () => {
      //     window.location.href = this.$common.configs.SWAP_URL;
      //   }
      // },
      // {
      //   icon: require("@/assets/images/icon_auto_trade.png"),
      //   title: this.$t("tools.auto-trade"),
      //   disable: true,
      //   description: this.$t("tools.auto-trade.description"),
      //   handler: (vue: Vue) =>
      //     vue.$helper.toFusionPath(vue, "trade", {
      //       name: "auto"
      //     })
      // },
      {
        icon: require("@/assets/images/icon_survey.png"),
        title: this.$t("tools.suvery"),
        description: this.$t("tools.suvery.description"),
        handler: (vue: Vue) =>
          vue.$helper.toFusionPath(vue, "basis", {
            name: "survey"
          })
      },
      // {
      //   icon: require("@/assets/images/icon_usdt_change.png"),
      //   title: this.$t("tools.usdt-exchange"),
      //   description: this.$t("tools.usdt-exchange.description"),
      //   handler: (vue: Vue) =>
      //     vue.$helper.toFusionPath(vue, "trade", {
      //       name: "convert-usdt"
      //     })
      // },
      // {
      //   cols: 6,
      //   icon: require("@/assets/images/icon_zotc.png"),
      //   title: this.$t("tools.zotc"),
      //   description: this.$t("tools.zotc.description"),
      //   handler: () => {
      //     window.location.href = this.$common.configs.OTC_URL;
      //   }
      // },
      // {
      //   cols: 6,
      //   icon: require("@/assets/images/icon_cash_in.png"),
      //   title: this.$t("trade.cash-in"),
      //   description: this.$t("trade.cash-in.description"),
      //   handler: () => {
      //     this.$router.push({ name: "trade-fiat-wyre" });
      //   }
      // },
      {
        cols: 6,
        icon: require("@/assets/images/icon_box_decompose.png"),
        title: this.$t("trade.box-decompose"),
        description: this.$t("trade.box-decompose.description"),
        handler: () => {
          if (!this.$store.state.app.config.box_unpack_disabled) {
            this.handleBoxDecompose();
          } else {
            showServiceDisabled(this);
          }
        }
      }
      // {
      //   cols: 6,
      //   icon: require("@/assets/images/icon_borrow.png"),
      //   title: this.$t("trade.borrow"),
      //   description: this.$t("trade.borrow.description"),
      //   handler: () => this.handleBorrow()
      // }
      // {
      //   cols: 6,
      //   icon: require("@/assets/images/icon_loan.png"),
      //   title: this.$t("common.debit"),
      //   description: this.$t("tools.debit.description"),
      //   disable: false,
      //   handler: () => {
      //     this.$common.utils.helper.toFusionPath(this, "defi", {
      //       name: "loan"
      //     });
      //   }
      // }
    ];
  }

  handleBoxDecompose() {
    this.$common.utils.helper.toFusionPath(this, "basis", {
      name: "tools-box_decompose"
    });
  }

  async handleBorrow() {
    this.$common.utils.helper.message(
      this,
      {
        title: this.$t("trade.borrow") as string,
        description: this.$t("defi.debit.warn.description") as string,
        ok: this.$t("defi.debit.warn.ok") as string
      },
      {
        onOK: async () => {
          const resp = await this.$api.defi.getLoanConversation();

          window.location.href = resp.url;
        }
      }
    );
  }

  handleToolAction(tool) {
    if (tool.disable) {
      return;
    }
    if (!this.isLogged) {
      this.$common.utils.helper.requestLogin(this);
      return;
    }
    tool.handler(this);
  }
}
export default Tools;
